// extracted by mini-css-extract-plugin
export default {"Card":"CharacterCard_Card__CGuHx","CardBody":"CharacterCard_CardBody__-4y5i","DeleteIcon":"CharacterCard_DeleteIcon__Uh5Dt","DeleteButton":"CharacterCard_DeleteButton__ocwat"};